import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import es from "./locales/es.json";

export const SUPPORTED_LANGS = ["es", "en"] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

const stored = (typeof localStorage !== "undefined" && localStorage.getItem("lang")) as SupportedLang | null;
const initial: SupportedLang = stored && SUPPORTED_LANGS.includes(stored) ? stored : "es";

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: initial,
  fallbackLng: "es",
  interpolation: { escapeValue: false },
});

export function setLang(lang: SupportedLang) {
  void i18n.changeLanguage(lang);
  try {
    localStorage.setItem("lang", lang);
  } catch {
    /* ignore */
  }
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", lang);
  }
}

if (typeof document !== "undefined") {
  document.documentElement.setAttribute("lang", initial);
}

export default i18n;
